const escapeHtml = value =>
  String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')

// createGalleryItemsKey 生成仅包含可渲染字段的稳定灯箱内容签名。
export const createGalleryItemsKey = (items = []) => JSON.stringify(
  items.map(item => [
    String(item?.src || ''),
    String(item?.alt || ''),
    String(item?.subHtml || '')
  ])
)

export const toStaticGalleryItem = (source = {}) => {
  const src = String(source.src || '').trim()
  if (!src) return null
  const title = String(source.title || '').trim()
  const alt = String(source.alt || '').trim()
  const badges = source.isHDR ? '<span class="blog-lightbox-badge">HDR</span>' : ''
  return {
    src,
    alt: alt || undefined,
    subHtml: title || badges
      ? `<div class="blog-lightbox-caption">${title ? `<p>${escapeHtml(title)}</p>` : ''}${badges ? `<div>${badges}</div>` : ''}</div>`
      : undefined
  }
}
